import { BackButton } from '../../Clickables/Controls/BackButton/BackButton';
import { ForwardButton } from '../../Clickables/Controls/ForwardButton/ForwardButton';

interface IProps {
  onClick: () => void;
  direction: 'left' | 'right';
}

export const ScrollButton = ({ onClick, direction }: IProps) => (
  <div
    className={`${direction === 'right' ? 'right-0' : 'left-0'} absolute flex h-full items-center justify-end`}
  >
    {direction === 'left' ? (
      <BackButton
        aria-label="Back to the last image"
        className="z-mid m-4"
        onClick={onClick}
        variant="controlLakeFogBg"
      />
    ) : (
      <ForwardButton
        aria-label="Forward to the next image"
        className="z-mid m-4"
        onClick={onClick}
        variant="controlLakeFogBg"
      />
    )}
  </div>
);
